import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var CopySVG = function CopySVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.975,27.941l3,.013V30H7.034a2.062,2.062,0,0,1-2.059-2.059V25H6.987Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.975 27.979 15.975 30 11.975 30 11.975 27.962 15.975 27.979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.916,28l.059-2h2v1.941A2.062,2.062,0,0,1,20.916,30H17.975V27.988Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.975,12.059A2.062,2.062,0,0,1,7.034,10H8.975v2H7.034l-.013,3H4.975Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.013 17 6.996 23 4.975 23 4.975 17 7.013 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.084,2H26.866a2.109,2.109,0,0,1,2.109,2.109V21.892A2.108,2.108,0,0,1,26.867,24H13.084a2.108,2.108,0,0,1-2.108-2.108V4.109A2.109,2.109,0,0,1,13.084,2Z"
  })));
};
CopySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
CopySVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Copy")
};
export default withIcon(CopySVG);